const Card = ({ children }) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card ">
                    <div className="card-header ">
                        <div className="row">

                        </div>
                    </div>
                    <div className="card-body ">
                        <div className="mixed-chart">
                            {children}
                        </div>
                    </div>
                    <div className="card-footer ">
                        <hr />
                        <div className="stats">
                            <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card;